import { int } from "@goodgamestudios/math-utilities";

export class Balancing {
    public static START_XP: number = 0;
    public static START_CHIPS: number = 500;
    public static START_GOLD: number = 0;

    public static REG_CHIPS: number = 1000;
    public static REG_GOLD: number = 5;

    public static EMAILVALIDATION_CHIPS: number = 5000;
    public static EMAILVALIDATION_GOLD: number = 5;

    public static CREATE_TABLE_GOLD: number = 5;

    public static XP_FACTOR: number = 1000;
    public static XP_POTENCY: number = 2;

    public static BIGBLIND_FACTOR: number = 2;
    public static MIN_BUYIN_FACTOR: number = 20;
    public static MIN_BUYIN_50BB_FACTOR: number = 100;
    public static MAX_BUYIN_FACTOR: number = 400;

    public static DEFAULT_ACTION_SECONDS: number = 20;
    public static FASTTABLE_ACTION_SECONDS: number = 10;

    public static DEFAULT_EMPTY_TABLES_PER_TYPE: number = 2;
    public static FASTTABLE_EMPTY_TABLES_PER_TYPE: number = 1;
    public static MIN50BB_EMPTY_TABLES_PER_TYPE: number = 1;

    public static TOURNAMENT_SHOOTOUT_MAXPLAYERS: number = 729;
    public static TOURNAMENT_FREEZEOUT_MAXPLAYERS: number = 900;
    public static SECONDS_BEFORE_GAME_START: number = 5;
    public static TABLE_COOLDOWN_SECONDS: number = 60;

    public static TOURNAMENT_DEFAULT_ENTRYCHIPS: number = 5000;
    public static TOURNAMENT_DEFAULT_ENTRYGOLD: number = 0;

    public static SCORE_LIMIT: number = 10;

    public static LEVELUP_CHIPS_FACTOR: number = 2000;
    public static LEVELUP_CHIPS_POTENCY: number = 1.08;

    public static LEVELUP_GOLD_INC_EVERY_X_LEVEL: number = 5;
    public static LEVELUP_GOLD_MAX: number = 40;

    public static MAX_GIVECHIPS_PER_DAY_FRIENDS: number = 1000;
    public static MAX_GIVECHIPS_PER_DAY_OTHERS: number = 250;

    public static TABLE_GIFT_PRICE_CHIPS_MIN: number = 5;

    public static TUTORIAL_BONUS_CHIPS: number = 1000;
    public static TUTORIAL_BONUS_GOLD: number = 3;
    public static TUTORIAL_BONUS_XP: number = 1250;

    public static BROKE_CHIPS: number = 1000;

    public static SITNGO_SECONDS_TO_START: number = 15;

    public static SHOWDOWN_HOLECARD_SECONDS: number = 1;
    public static SHOWDOWN_COMMUNITYCARD_SECONDS: number = 2;

    public static SLOTMACHINE_MIN_LEVEL: number = 3;
    public static SLOTMACHINE_CHIPS_MIN_INPUT_FACTOR: number = 0.001;
    public static SLOTMACHINE_CHIPS_MAX_INPUT_FACTOR: number = 0.2;
    public static SLOTMACHINE_GOLD_MIN_INPUT: number = 1;
    public static SLOTMACHINE_GOLD_MAX_INPUT: number = 100;

    public static REMINDER_DAYS_1: number = 4;
    public static REMINDER_DAYS_2: number = 10;
    public static REMINDER_DAYS_3: number = 17;

    public static COMEBACK_BONUS_CHIPS_2: number = 2000;
    public static COMEBACK_BONUS_GOLD_2: number = 5;
    public static COMEBACK_BONUS_CHIPS_3: number = 5000;
    public static COMEBACK_BONUS_GOLD_3: number = 10;

    public static RABBIT_CAM_GOLD_COST: number = 1;

    public static calcLevelFromXP(xp: number): number {
        var f: number = Number(xp / 1000);
        return int(int(Math.sqrt(f)));
    }

    public static calcXpFromLevel(level: number): number {
        var f: number = Number(Math.pow(level, 2));
        return Math.round(f * 1000);
    }

    public static calcChipsBonusForLevelUp(level: number): number {
        if (level < 20)
            return Math.round((Math.pow(level, 1.08) * 2000) / 100) * 100;

        return level * 2500;
    }

    public static calcGoldBonusForLevelUp(): number {
        return 1;
    }
}
